import axios from "axios";
import { t } from "../texts.js";

// Input Search
let inputSearch = document.querySelectorAll(".input input");

// Input default style
Array.from(inputSearch).forEach((e) => {
  // Input state
  e.addEventListener("input", (input) => {
    let inputContainer = input.currentTarget.parentNode.closest(".input");

    if (input.currentTarget.value.length !== 0) {
      inputContainer.classList.add("input--no-empty");
    } else {
      inputContainer.classList.remove("input--no-empty");
    }
  });

  // Focus state
  e.addEventListener("focus", (input) => {
    let inputContainer = input.currentTarget.parentNode.closest(".input");
    inputContainer.classList.add("input--focus");
  });

  // UnFocus state
  e.addEventListener("focusout", (input) => {
    let inputContainer = input.currentTarget.parentNode.closest(".input");
    inputContainer.classList.remove("input--focus");
  });
});

// the footer's sign-up message: "Thank you!" or what went wrong
function newsletterMessage(kind, text) {
  document
    .querySelectorAll(".footer__newsletter .success, .footer__newsletter .error")
    .forEach((el) => el.remove());
  const span = document.createElement("span");
  span.className = kind;
  span.textContent = text;
  document.querySelector(".footer__newsletter").appendChild(span);
}

// straight to Mailchimp's embedded form (its JSONP address, so no server of ours is involved)
function subscribeAtMailchimp(form) {
  const input = form.querySelector("input[type=email]");
  const callback = "ogMailchimp" + Date.now();
  const script = document.createElement("script");
  const done = () => {
    delete window[callback];
    script.remove();
  };
  window[callback] = (answer) => {
    done();
    if (answer && answer.result === "success") {
      newsletterMessage("success", t("Thank you!"));
      input.value = "";
    } else {
      const text = String((answer && answer.msg) || "").replace(/<[^>]*>/g, "").replace(/^\d+ - /, "");
      newsletterMessage("error", text || t("The newsletter sign-up didn't go through. Please try again later."));
    }
  };
  script.onerror = () => {
    done();
    newsletterMessage("error", t("The newsletter sign-up didn't go through. Please try again later."));
  };
  const address = form.dataset.mailchimp.replace("/subscribe/post?", "/subscribe/post-json?").replace(/&amp;/g, "&");
  script.src = address + "&EMAIL=" + encodeURIComponent(input.value) + "&c=" + callback;
  document.body.appendChild(script);
}

try {
  // Newsletter subscribe
  let formSubscribe = document.querySelector("#form-subscribe");

  formSubscribe.addEventListener("submit", (e) => {
    e.preventDefault();
    // Settings › Newsletter can send sign-ups straight to Mailchimp's own form (data-mailchimp)
    if (e.target.dataset.mailchimp) {
      subscribeAtMailchimp(e.target);
      return;
    }
    let urlAction = e.target.getAttribute("action");
    axios({
      method: "GET",
      url: urlAction,
      // axios encodes it: pasted into the URL as-is, a "+" in the address
      // reached the server as a space, and an "&" cut the address short
      params: { email: e.target.querySelector("input[type=email]").value },
    })
      .then((response) => {
        if (response.status === 200 && response.data.success == "success") {
          document
            .querySelector(".footer__newsletter")
            .insertAdjacentHTML(
              "beforeend",
              `<span class="success">${t("Thank you!")}</span>`,
            );
          e.target.querySelector("input[type=email]").value = "";
        }

        if (response.status === 200 && response.data.failed) {
          if (response.data.failed.email) {
            document
              .querySelector(".footer__newsletter")
              .insertAdjacentHTML(
                "beforeend",
                `<span class="error">${response.data.failed.email}</span>`,
              );
          } else {
            document
              .querySelector(".footer__newsletter")
              .insertAdjacentHTML(
                "beforeend",
                `<span class="error">${t(response.data.failed)}</span>`,
              );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  });
} catch (err) {
  console.log(err);
}
